import React from 'react';

export default props => {
    return (
        <svg id="Favorittikon_Large" data-name="Favorittikon – Large" xmlns="http://www.w3.org/2000/svg" width="23.974px" height="21.598px" viewBox="0 0 23.974 21.598" fill={props.fill} className={props.className}>
            <path id="Favorittikon_Large-2" data-name="Favorittikon – Large" d="M-.654-45.96a7,7,0,0,0-5.059,2.194,7,7,0,0,0-5.059-2.194A6.881,6.881,0,0,0-17.7-39.113a6.923,6.923,0,0,0,1.91,4.774h.02l10.057,9.976,9.874-9.793a6.771,6.771,0,0,0,2.113-4.957A6.881,6.881,0,0,0-.654-45.96Zm0,1.056a5.832,5.832,0,0,1,5.872,5.79,5.709,5.709,0,0,1-1.788,4.206l-9.143,9.061-9.325-9.244h.02a5.686,5.686,0,0,1-1.625-4.023,5.832,5.832,0,0,1,5.872-5.79,5.985,5.985,0,0,1,5.059,2.865A5.985,5.985,0,0,1-.654-44.9Z" transform="translate(17.7 45.96)"/>
        </svg>
      
    );
}